"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeOrionModule = void 0;
const executeSingleNormalizer = (itemModule) => __awaiter(void 0, void 0, void 0, function* () {
    let { normalizer } = itemModule;
    normalizer = yield normalizer;
    normalizer = normalizer.default;
    return {
        name: itemModule.name,
        data: normalizer(itemModule.data, itemModule.userCompatibilities, itemModule.productCompatibilityGroup),
        moduleId: itemModule.moduleId,
    };
});
const orderByOrderModule = (modulesToOrder, orderModule, resNormalized) => {
    orderModule.value.data.forEach(({ idModule, nameModule }) => {
        var _a, _b;
        const modulo = modulesToOrder.filter((element) => {
            return element.value.moduleId == idModule;
        });
        resNormalized[nameModule] = (_b = (_a = modulo === null || modulo === void 0 ? void 0 : modulo[0]) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.data;
    });
    resNormalized["ORDEN_MODULOS"] = orderModule.value.data;
};
const parallelModules = (moduleName, data, orionAlias) => {
    let itemNormalized = null;
    switch (moduleName) {
        case "MODULO_TITLE_SUBTITLE":
        case "MODULO_H1":
            itemNormalized = {
                name: moduleName,
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/title-normalizer"))),
            };
            break;
        case "MODULO_BANNER_CTA":
        case "MODULO_BANNER":
            itemNormalized = {
                name: moduleName,
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/banner-normalizer"))),
            };
            break;
        case "MODULE_SECTION_IMAGE_SLIDER":
            itemNormalized = {
                name: moduleName,
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/image-slider-normalizer"))),
            };
            break;
        case "MODULO_SELECTORES_TV":
        case "MODULO_SELECTOR":
            itemNormalized = {
                name: moduleName,
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/selector-normalizer"))),
            };
            break;
        case "MODULO_MULTI_SELECTORES":
            itemNormalized = {
                name: moduleName,
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/multi-selector-normalizer"))),
            };
            break;
        case "MODULO_CARDS_FINANZAS":
            itemNormalized = {
                name: "MODULO_CARDS_FINANZAS",
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/distribox-normalizer"))),
            };
            break;
        case "MODULO_CARDS_LINEAS_MOVILES":
            itemNormalized = {
                name: "MODULO_CARDS",
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/distribox-normalizer-lineas-moviles/index.js"))),
            };
            break;
        case "MODULO_CARDS_BAF":
        case "MODULO_CARDS":
        case "MODULO_CARDS_SEGUROS":
        case "MODULO_CARD_FIBRA_ADICIONAL":
            itemNormalized = {
                name: "MODULO_CARDS",
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/distribox-normalizer"))),
            };
            break;
        case "DOBLE_BUYBOX":
            itemNormalized = {
                name: "MODULO_BUYBOX",
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/doble-buybox-normalizer"))),
            };
            break;
        case "MODULO_BUYBOX":
            itemNormalized = {
                name: moduleName,
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/buybox-normalizer"))),
            };
            break;
        case "DESCRIPTION_IMG":
            itemNormalized = {
                name: "MODULE_DESCRIPTION_IMG",
                data: data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/description-img-normalizer"))),
            };
            break;
        case "CARACTERISTICAS_TITLO_DESCRIPTION_HREF_ACTIVAR_ROAMING_V1":
            itemNormalized = {
                name: "MODULO_TITLEHREF_CONTENT_V1",
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/titlehref-normalizer"))),
            };
            break;
        case "CARACTERISTICAS_TITLO_DESCRIPTION_HREF_ACTIVAR_ROAMING":
            itemNormalized = {
                name: "MODULO_TITLEHREF_CONTENT",
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/titlehref-normalizer"))),
            };
            break;
        case "LISTADO_CARACTERISTICS_CARDS":
            itemNormalized = {
                name: "LISTADO_MODULO_CARACTERISTIC_CARDS",
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/roaming-characs-normalizer"))),
            };
            break;
        case "MODULO_CARDS-MAS-SERVICIOS":
        case "ZONAS_CONTRATO":
        case "ZONAS_CONTRATO_copy":
        case "MODULO_CARDS-DISTRI":
        case "MODULO_CARDS-MAS-SERVICIOS_DISTRI_SERVICIOS_GAMING":
        case "MODULO_CARDS-MAS-SERVICIOS_SALUD":
        case "MODULO_CARDS-MAS-SERVICIOS_SERVICIOS_ENERGIA":
        case "MODULO_CARDS-MAS-SERVICIOS_TEST_VELOCIDAD_CONEXION_SEGURA":
            itemNormalized = {
                name: "MODULO_CARDS",
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/distris-mas-servicios-normalizer"))),
            };
            break;
        case "MODULO_CARDS-MAS-SERVICIOS_SEGURIDAD":
            itemNormalized = {
                name: "MODULO_CARDS",
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/more-services-normalizer"))),
            };
            break;
        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_DISTRIBUTIVA_SEGURIDAD_PORQUE_ELEGIR_MOVISTAR":
        case "002_LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION":
        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_DISTRI_INTERNET_ELEGIR_FIBRA":
        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_TARIFAS_MOVILES_CONTRATO":
        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_DISTRI_PREPAGO":
        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_GAMING":
        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_DISTRI_ENERGIA":
        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION":
        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_SEGURO_1":
        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_QUE_MIDE_ELTEST":
        case "MODULO_LISTADO_CARACTERISTICAS_ICON_TITLE_DESCRIPTION":
            itemNormalized = {
                name: "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION",
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/districharacs-normalizer"))),
            };
            break;
        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_TemplateInstance_2b742737-9fc5-LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_DISTRIBUTIVA_SEGURIDAD_PORQUE_SERVICIOS_ADICIONALES-980f-c98f6d8d6df9_name":
        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_SERVICIOS_ADICIONALES_GAMING":
        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_DISTRI_ENERGIA_":
        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_DISTRI_ENERGIA_":
        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_DISTRI_ENERGIA_":
            itemNormalized = {
                name: "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_02",
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/districharacs-normalizer"))),
            };
            break;
        case "003_LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION":
        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_CONTRATACION_RAPIDA":
        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_TARIFAS_MOVILES_CONTRATO_NUMEROS":
        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_TARIFAS_MOVILES_CONTRATO_NUMEROS_LINEAS_ADICIONALES":
        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_NUMEROS_DISTRI_PREPAGO":
        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_FINANZAS_PAGOS_ONLINE":
        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_DISTRI_SALUD_CONTRATACION_ONLINE":
        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_TemplateInstance_9918e81d-54d3-44b8-ad63-97654903acfb_name":
        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_CONSEJOS_PARA_HACER_TEST":
            itemNormalized = {
                name: "LISTADO_PASOS_ICONO_TITULO_DESCRIPCION",
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/steplist-normalizer"))),
            };
            break;
        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_MOVISTAR_MONEY":
            itemNormalized = {
                name: "LISTADO_PASOS_ICONO_TITULO_DESCRIPCION_02",
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/steplist-normalizer"))),
            };
            break;
        case "MODULO_CARACTERISTIC_CARDS":
        case "MODULO_CARACTERISTICS_CARDS":
            itemNormalized = {
                name: "MODULO_CARACTERISTIC_CARDS",
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/characs-normalizer"))),
            };
            break;
        case "MODULO_RECOMENDACION":
        case "MODULO_ECOSYSTEM":
        case "MODULO_CARDS_CONTENIDOS_FILTER":
            itemNormalized = {
                name: moduleName,
                data: Object.assign(Object.assign({}, data), { orionAlias }),
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/recom-normalizer"))),
            };
            break;
        case "MODULO_VENTA_CRUZADA_OTROS_SERVICIOS":
        case "MODULO_VENTA_CRUZADA":
            itemNormalized = {
                name: moduleName,
                data: Object.assign(Object.assign({}, data), { orionAlias }),
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/interest-normalizer"))),
            };
            break;
        case "MODULO_CARDS_VENTA_CRUZADA":
            itemNormalized = {
                name: moduleName,
                data: Object.assign(Object.assign({}, data), { orionAlias }),
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/safebox-normalizer"))),
            };
            break;
        case "FAQS_PREGUNTAS_FRECUENTES_RECOM":
            itemNormalized = {
                name: "FAQS_PREGUNTAS_FRECUENTES_RECOM",
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/faqs-normalizer"))),
            };
            break;
        case "FAQS_PREGUNTAS_FRECUENTES_FIBRA_600MB_NEW":
        case "FAQS_PREGUNTAS_FRECUENTES":
            itemNormalized = {
                name: "FAQS_PREGUNTAS_FRECUENTES",
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/faqs-normalizer"))),
            };
            break;
        case "FAQS_EXPANDIDAS":
            itemNormalized = {
                name: "FAQS_EXPANDIDAS",
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/expandable-text-normalizer"))),
            };
            break;
        case "FAQS_PREGUNTAS_FRECUENTES_RECOM_IMG":
        case "FAQS_PREGUNTAS_FRECUENTES_RECOM_IMG_02":
        case "FAQS_PREGUNTAS_FRECUENTES_RECOM_IMG_03":
            itemNormalized = {
                name: moduleName,
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/faqs-normalizer"))),
            };
            break;
        case "COMPONENT_TYPE":
            itemNormalized = {
                name: "COMPONENT_TYPE",
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/custo-component-normalizer"))),
            };
            break;
        case "MODULE_DESCRIPTION_IMG_03":
            itemNormalized = {
                name: "MODULE_DESCRIPTION_IMG_03",
                data: data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/description-img-normalizer"))),
            };
            break;
        case "MODULE_DESCRIPTION_IMG_01":
            itemNormalized = {
                name: "MODULE_DESCRIPTION_IMG_01",
                data: data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/description-img-normalizer"))),
            };
            break;
        case "MODULE_DESCRIPTION_IMG_02":
            itemNormalized = {
                name: "MODULE_DESCRIPTION_IMG_02",
                data: data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/description-img-normalizer"))),
            };
            break;
        case "MODULE_DESCRIPTION_IMG":
            itemNormalized = {
                name: "MODULE_DESCRIPTION_IMG",
                data: data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/description-img-normalizer"))),
            };
            break;
        case "MODULO_IMAGENES_CATEGORIA":
        case "MODULO_LISTADO_CONTENIDOS_IMAGENES_EXTRA":
            itemNormalized = {
                name: moduleName,
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/tv-module-normalizer"))),
            };
            break;
        case "MODULO_SIMPLEPHONE":
            itemNormalized = {
                name: "MODULO_SIMPLEPHONE",
                data: data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/simple-phone-normalizer"))),
            };
            break;
        case "MODULO_SIMPLEPHONE_FICHA":
            itemNormalized = {
                name: "MODULO_SIMPLEPHONE_FICHA",
                data: data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/simple-phone-normalizer"))),
            };
            break;
        case "MODULO_PACK_CARD":
            itemNormalized = {
                name: moduleName,
                data: Object.assign(Object.assign({}, data), { orionAlias }),
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/tv-card-normalizer"))),
            };
            break;
        case "MODULO_FILTER_CATEGORY":
            itemNormalized = {
                name: moduleName,
                data: Object.assign(Object.assign({}, data), { orionAlias }),
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/tv-card-normalizer"))),
            };
            break;
        case "MODULO_SIMPLE_CARD":
            itemNormalized = {
                name: moduleName,
                data: Object.assign(Object.assign({}, data), { orionAlias }),
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/tv-card-normalizer"))),
            };
            break;
        case "MODULO_CATEGORY_PACK_TV":
            itemNormalized = {
                name: moduleName,
                data: Object.assign(Object.assign({}, data), { orionAlias }),
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/tv-channels-normalizer"))),
            };
            break;
        case "EMBED-CONTAINER":
        case "EMBED-CONTAINER_VIDEO": //new
            itemNormalized = {
                name: moduleName,
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/iframe-normalizer"))),
            };
            break;
        case "MODULO_PRINCIPAL_CONTRATOS_MANUALES_PRECIOS_SERVICIOS_TELEFONIA":
        case "MODULO_PRINCIPAL_CONTRATOS_MIMOVISTAR":
        case "MODULO_PRINCIPAL_CONTRATOS_MOVISTAR_FUSION":
        case "MODULO_PRINCIPAL_TV_CONTRATOS_MOVISTAR_PLUS":
        case "MODULO_PRINCIPAL_CONTRATOS_INTERNET_BANDA_ANCHA":
        case "MODULO_PRINCIPAL_CONTRATOS_RELOJ_TECUIDA":
        case "MODULO_PRINCIPAL_CONTRATOS_MOVIL_CONDICIONES_GENERALES":
        case "MODULO_PRINCIPAL_CONTRATOS_FIJO":
        case "MODULO_PRINCIPAL_CONTRATOS_PUESTOS_TRABAJO":
        case "MODULO_PRINCIPAL_CONTRATOS_SOLUCIONES_DIGITALES":
        case "MODULO_PRINCIPAL_CONTRATOS_CONDICIONES_ATENCION_CLIENTE":
        case "MODULO_PRINCIPAL_CONTRATOS_CONDICIONES_GENERALES_PARTICULARES_TRADUCIDAS":
        case "MODULO_PRINCIPAL_CONTRATOS_DESESTIMIENTO_CANCELACION_PORTABILIDAD":
        case "MODULO_PRINCIPAL_CONTRATOS_VERIFICACION_IDENTIDAD":
        case "MODULO_PRINCIPAL_CONTRATOS_MOVIL_HISTORICO":
            itemNormalized = {
                name: moduleName,
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/contratos-normalizer"))),
            };
            break;
        case "MODULO_LIST_CONTRATOS":
            itemNormalized = {
                name: moduleName,
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/contratos-list-normalizer"))),
            };
            break;
        case "MODULO_LLAMADAS_CONDICIONES_PAISES_EXCEPCIONES_PAISES":
        case "MODULO_ROAMING_CONDICIONES_PAISES":
        case "INFORMACION_ADICIONAL":
            itemNormalized = {
                name: moduleName,
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/roaming-info-normalizer"))),
            };
            break;
        case "BONOS_TARIFAS_INTERNACIONALES":
            itemNormalized = {
                name: moduleName,
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/bonos-normalizer"))),
            };
            break;
        case "MODULO_CARACTERISTICS_HORIZONTAL":
            itemNormalized = {
                name: moduleName,
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/guide-list-normalizer"))),
            };
            break;
        case "MODULO_ACTIVACION":
            itemNormalized = {
                name: moduleName,
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/activacion-normalizer"))),
            };
            break;
        case "ORDEN_MODULOS":
            itemNormalized = {
                name: moduleName,
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/order-normalizer"))),
            };
            break;
        case "MODULO_DESCRIPTION_PICTURE":
            itemNormalized = {
                name: moduleName,
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/description-picture-normalizer"))),
            };
            break;
        case "COMPONENT_CARD_LIST":
            itemNormalized = {
                name: moduleName,
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/card-list-flyout-normalizer"))),
            };
            break;
        case "MODULO_TELETIPO":
            itemNormalized = {
                name: moduleName,
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/teletipo-normalizer"))),
            };
            break;
        case "MODULOS_TELETIPOS":
            itemNormalized = {
                name: moduleName,
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/teletipos-normalizer"))),
            };
            break;
        case "ICON_ECOSYSTEM_PROSEGUR":
            itemNormalized = {
                name: moduleName,
                data,
                normalizer: Promise.resolve().then(() => __importStar(require("./modules-normalizers/advantages-normalizer"))),
            };
            break;
        default:
            break;
    }
    return itemNormalized;
};
/**
 * Normaliza los modulos que vienen desde catálogo a una estructura válida
 * @param {Object[]} ModuleList - lista de los modulos  que viene desde catálogo
 * @returns {Object[]} - lista de modulos  normalizados
 */
const normalizeOrionModule = (response, context, orionAlias = "", userCompatibilities, productCompatibilityGroup, hash = "") => __awaiter(void 0, void 0, void 0, function* () {
    global.hash = hash;
    const resNormalized = {};
    let parallelModulesList = [];
    const myModule = (response && response.data) || null;
    resNormalized.alias = response.alias;
    // generamos normalizciones en base a la respuesta de orion
    if (myModule && myModule.fields) {
        const currentModules = Object.assign({}, myModule.fields);
        const fieldsInfoKeys = Object.keys(currentModules);
        fieldsInfoKeys.forEach((fieldsInfoKey) => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            const currentModule = currentModules[fieldsInfoKey];
            const currentModuleName = (currentModule === null || currentModule === void 0 ? void 0 : currentModule.name) || ((_a = currentModule[0]) === null || _a === void 0 ? void 0 : _a.name);
            if (!currentModuleName)
                return null;
            const itemNormalized = parallelModules(currentModuleName, currentModule, orionAlias);
            if (itemNormalized) {
                itemNormalized.moduleId = fieldsInfoKey;
                if (userCompatibilities && productCompatibilityGroup) {
                    itemNormalized.userCompatibilities = userCompatibilities;
                    itemNormalized.productCompatibilityGroup = productCompatibilityGroup;
                }
                parallelModulesList.push(itemNormalized);
            }
        }));
    }
    // ejecutamos normalizaciones detectadas
    parallelModulesList = parallelModulesList.map((item) => executeSingleNormalizer(item));
    const frontModules = yield Promise.allSettled(parallelModulesList);
    try {
        const countModuleNames = [];
        const orderModule = frontModules.filter((element) => {
            return element.value.moduleId == "ORDEN_MODULOS";
        });
        if (orderModule.length > 0) {
            orderByOrderModule(frontModules, orderModule[0], resNormalized);
        }
        else {
            frontModules.forEach(({ status, value }) => {
                const { data, name } = value;
                if (countModuleNames[name]) {
                    countModuleNames[name]++;
                }
                else {
                    countModuleNames[name] = 1;
                }
                if (countModuleNames[name] > 1) {
                    resNormalized[`${name}_${countModuleNames[name]}`] = data;
                }
                else {
                    resNormalized[name] = data;
                }
            });
        }
    }
    catch (err) {
        frontModules.forEach(({ status, value }) => {
            const { data, name } = value;
            resNormalized[name] = data;
        });
    }
    return resNormalized;
});
exports.normalizeOrionModule = normalizeOrionModule;
exports.default = exports.normalizeOrionModule;
//# sourceMappingURL=index.js.map